/**
 * Referral share channels: the short `via` tag on shared links (/r/alex?via=wa).
 * CommonJS so the browser (share buttons, capture) and Netlify functions (landing, visit, claim,
 * admin) use one allowlist, like src/config/localTest.js. Keep it ES5-style: no destructuring.
 *
 * Stored values: one of VIA_CODES, 'direct' (no tag) or 'other' (an unrecognised tag).
 */
var BASE = ['copy', 'msg', 'wa', 'tg', 'share'];
var VIA_CODES = BASE.concat(BASE.map(function (code) { return 'n' + code; }));
var VIA_LABELS = {
  copy: 'Copied link', msg: 'Invite message', wa: 'WhatsApp', tg: 'Telegram', share: 'Share sheet',
  ncopy: 'Navbar: copied link', nmsg: 'Navbar: invite message', nwa: 'Navbar: WhatsApp', ntg: 'Navbar: Telegram',
  nshare: 'Navbar: share sheet', direct: 'Plain link (no tag)', other: 'Other / unknown tag',
};
/** Share-button channel (analytics name) → via code; `source: 'nav'` prefixes "n". */
var CHANNEL_VIA = { copy_link: 'copy', copy_message: 'msg', whatsapp: 'wa', telegram: 'tg', native: 'share' };

function viaFor(channel, source) {
  var code = CHANNEL_VIA[channel];
  if (!code) return '';
  return source === 'nav' ? 'n' + code : code;
}

/** Missing → 'direct'; allowlisted → itself; anything else → 'other'. Never echoes raw input. */
function normalizeVia(raw) {
  if (raw === undefined || raw === null || String(raw).trim() === '') return 'direct';
  var value = String(raw).trim().toLowerCase();
  // 'direct' / 'other' are its own outputs: re-normalizing a stored value must not change it.
  return VIA_CODES.indexOf(value) !== -1 || value === 'direct' || value === 'other' ? value : 'other';
}

/** The /r/ link with its channel tag; the plain link is returned unchanged for an unknown channel. */
function withVia(link, via) {
  return via && VIA_CODES.indexOf(via) !== -1 ? link + (link.indexOf('?') === -1 ? '?' : '&') + 'via=' + via : link;
}

module.exports = { VIA_CODES: VIA_CODES, VIA_LABELS: VIA_LABELS, viaFor: viaFor, normalizeVia: normalizeVia, withVia: withVia };
